import React from "react";
import styled, { css } from "styled-components";
import { useShop } from "../../context/ShopContext";
import { CartButton } from "./CartButton";
import { GrFormClose } from "react-icons/gr";
import { NumberInput } from "../NumberInput";
import { RiDeleteBinLine } from "react-icons/ri";
import { Button } from "../Button";

const CartWrapper = styled.div<{ isCartOpen: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 300px;
  background: #fff;
  z-index: 999;
  transition: transform 0.15s ease-in-out;
  transform: translateX(${(props) => (props.isCartOpen ? 0 : 100)}%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  ${(props) =>
    props.isCartOpen &&
    css`
      box-shadow: -4px 0px 15px 1px rgba(0, 0, 0, 0.64);
    `}
`;

const CloseIcon = styled(GrFormClose)`
  position: absolute;
  top: 21px;
  right: 8px;
  cursor: pointer;
  &:hover {
    transform: scale(1.1);
  }
`;

const CartTitle = styled.h1`
  position: absolute;
  top: 0;
  left: 30px;
  font-weight: 400;
`;

const ItemsWrapper = styled.div`
  width: 90%;
  margin: 5%;
  margin-top: 70px;
  max-height: 80%;
  overflow-y: auto;
`;

const Item = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  padding: 1rem;
`;
const ItemImage = styled.img`
  width: 30%;
`;
const ItemInfo = styled.div`
  width: 80%;
  margin: 0;
  padding: 0;
  height: 100px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  position: relative;
  h2,
  h3,
  p {
    margin: 3px;
    font-weight: 400;
  }
  h2 {
    font-size: 0.8em;
  }
  h3 {
    font-size: 0.75em;
    font-weight: bold;
  }
`;
const ItemInfoBottom = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin: 0;
  padding: 0;
  width: 100%;
`;
const ItemDeleteBin = styled(RiDeleteBinLine)`
  cursor: pointer;
`;

const FooterWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
const CheckoutAnchor = styled.a`
  width: 90%;
  padding-bottom: 20px;
  display: inline-block;
`;
const CheckoutButton = styled(Button)`
  margin: 0;
  width: 100%;
`;

export interface CartProps {}

export const Cart: React.FC<CartProps> = ({}) => {
  const {
    lineItems,
    isCartOpen,
    openCart,
    closeCart,
    removeItemFromCheckout,
    setQuantityOfItemInCheckout,
    checkoutInfo,
    getTotalPrice,
  } = useShop();

  return (
    <>
      <CartButton onClick={openCart} amountItems={lineItems.length} />
      <CartWrapper isCartOpen={isCartOpen}>
        <CloseIcon size={40} onClick={closeCart} />
        <CartTitle>C*RT</CartTitle>
        <ItemsWrapper>
          {lineItems.length === 0 ? (
            <p>Your cart is empty...</p>
          ) : (
            lineItems.map((item) => (
              <Item key={item.id}>
                <ItemImage src={item.variant?.image?.transformedSrc} />
                <ItemInfo>
                  <h2>{item.title}</h2>
                  <h3>
                    {item.variant?.title !== "Default Title"
                      ? item.variant?.title
                      : ""}
                  </h3>
                  <ItemInfoBottom>
                    <NumberInput
                      number={item.quantity}
                      onIncrement={() =>
                        setQuantityOfItemInCheckout(item, item.quantity + 1)
                      }
                      onDecrement={() =>
                        setQuantityOfItemInCheckout(item, item.quantity - 1)
                      }
                    />
                    <p>
                      €
                      {(item.variant?.priceV2.amount * item.quantity).toFixed(2)}
                    </p>
                    <ItemDeleteBin
                      onClick={() => removeItemFromCheckout(item.id)}
                      size={20}
                    />
                  </ItemInfoBottom>
                </ItemInfo>
              </Item>
            ))
          )}
        </ItemsWrapper>
        <FooterWrapper>
          <p style={{ margin: "10px 0" }}>
            Total: €{getTotalPrice().toFixed(2)}
          </p>
          <CheckoutAnchor
            href={checkoutInfo?.webUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <CheckoutButton primary>CHECKOUT</CheckoutButton>
          </CheckoutAnchor>
        </FooterWrapper>
      </CartWrapper>
    </>
  );
};
